import i18n from '@/i18n'
import talentPoolLayout from './index'
import TalentFilterGroupList from './talentFilterGroup/list'
import { TAB_CATEGORY } from '@/constant/permission'

const basePath = '/v-admin/talent-pool'

const talentFilterGroupListRoute = {
  name: 'talentFilterGroupList',
  path: `${basePath}/talent-filter-group/`,
  redirect: `${basePath}/group-list`,
  component: TalentFilterGroupList,
  meta: {
    titleI18nKey: 'admin.crm.title.talentFilterGroup',
    // crm menu
    menu: {
      get label () {
        return i18n.t('admin.crm.title.talentFilterGroup')
      }
    }
  }
}

export default {
  name: 'talentPoolLayout',
  path: basePath,
  component: talentPoolLayout,
  redirect: talentFilterGroupListRoute.path,
  meta: {
    permission: TAB_CATEGORY.TALENT_POOL,
    isInclude: true,
    get title () {
      return i18n.t('admin.talent.pool.title')
    },
    tab: {
      get label () {
        return i18n.t('admin.talent.pool.tab')
      }
    }
  },
  children: [
    talentFilterGroupListRoute
  ]
}

export {
  talentFilterGroupListRoute
}
